import { z } from 'zod'

import { createEnv } from '@isoapp/common/env/createEnv'

export const env = createEnv({
  client: {
    NEXT_PUBLIC_DISTRICT_IMAGE_OPTIMIZATION_SIZE_JUMP_HACK: z.stringbool().default(false),
  },
  experimental__runtimeEnv: {
    NEXT_PUBLIC_DISTRICT_IMAGE_OPTIMIZATION_SIZE_JUMP_HACK:
      process.env.NEXT_PUBLIC_DISTRICT_IMAGE_OPTIMIZATION_SIZE_JUMP_HACK,
  },
})
